import { NetworkStatus } from '@apollo/client';
import { EmptyState } from '@synoptic/ui-kit/empty-state/empty-state.js';
import { PostIcon } from '@synoptic/ui-kit/icons/react/post.js';
import { List } from '@/components/highlighted-feed-wrapper/highlighted-feed-wrapper.tsx';
import { PostFeed } from '@/components/post-feed/post-feed.tsx';
import { emptyState } from './page.css.ts';
import { usePublicStreamPosts } from './use-public-stream-posts.ts';

export const StreamPreviewFeed = ({
  streamId,
  skeletonItemCount,
}: {
  streamId: string;
  skeletonItemCount?: number;
}) => {
  const {
    data: { publicStreamPostPreview },
    networkStatus,
  } = usePublicStreamPosts(streamId);

  return publicStreamPostPreview.items.length === 0 ? (
    <EmptyState
      className={emptyState}
      illustration={<PostIcon />}
      heading="No preview posts yet"
    />
  ) : (
    <PostFeed
      style={{
        opacity: networkStatus === NetworkStatus.loading ? 0.5 : '',
      }}
      data={publicStreamPostPreview.items}
      initialItemCount={skeletonItemCount}
      components={{
        List,
      }}
      gap={0}
    />
  );
};
